var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-component"},[_c('div',{staticClass:"total"},[_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"sub-title"},[_c('span',[_vm._v(_vm._s(_vm.name))]),(_vm.required)?_c('span',{staticClass:"star"},[_vm._v("*")]):_vm._e()])]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-invoice"},[_c('i',{staticClass:"el-icon-plus"})])
}]

export { render, staticRenderFns }